module.exports = __webpack_public_path__ + "530d946adca85f1635aba3f0a2b336e9.jpg";